import { ActionWithPayload, RehydrateOptions } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { AUTH_TRANSACTION_ACTION_TYPE } from "./auth-transaction.action";
import { AuthTransactionState, VerificationStatus, VerificationStatusResponse } from "./auth-transaction.model";

const INITIAL_STATE: AuthTransactionState = {
	verificationStatus: undefined,
	shouldRememberUser: undefined,
	authenticationToken: undefined,
	lastActivePersonalNumber: undefined,
};

const REHYDRATE_OPTIONS: RehydrateOptions<AuthTransactionState> = {
	name: "authTransactionReducer",
	excludeProps: ["verificationStatus", "authenticationToken", "shouldRememberUser", "verificationCode"],
};

export function authTransactionReducer(state = INITIAL_STATE, action: ActionWithPayload): AuthTransactionState {
	const response = action.payload as VerificationStatusResponse;

	switch (action.type) {
		case AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatus: {
			return updateState(state, {
				verificationStatus: VerificationStatus.Pending,
				authenticationToken: undefined,
				verificationCode: response.verificationCode,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatusPending: {
			return updateState(state, {
				verificationStatus: response.status,
				authenticationToken: response.authenticationToken,
				verificationCode: response.verificationCode,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatusSuccess: {
			return updateState(state, {
				verificationStatus: response.status,
				authenticationToken: response.authenticationToken,
				lastActivePersonalNumber: keepPersonalNumber(state, response),
				verificationCode: response.verificationCode,
				qrCode: undefined,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatusFail:
		case AUTH_TRANSACTION_ACTION_TYPE.initializeVerificationFail:
		case AUTH_TRANSACTION_ACTION_TYPE.cancelLastVerificationSuccess: {
			return updateState(state, {
				verificationStatus: VerificationStatus.Failed,
				authenticationToken: undefined,
				qrCode: undefined,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.resetVerificationStatus: {
			return updateState(state, {
				verificationStatus: undefined,
				shouldRememberUser: undefined,
				verificationCode: undefined,
				qrCode: undefined,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction: {
			return updateState(state, {
				shouldRememberUser: action.payload && action.payload.shouldRememberUser,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.initializeVerification:
		case AUTH_TRANSACTION_ACTION_TYPE.reset: {
			return updateState(state, {
				verificationStatus: undefined,
				authenticationToken: undefined,
				qrCode: undefined,
			});
		}
		case AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransactionSuccess:
			return updateState(state, {
				qrCode: action.payload.qrCode,
			});
		default:
			return state;
	}
}

function keepPersonalNumber(state: AuthTransactionState, response: VerificationStatusResponse): string | undefined {
	return (typeof state.shouldRememberUser === "undefined" && !!state.lastActivePersonalNumber) ||
		!!state.shouldRememberUser
		? response.personalNumber
		: undefined;
}

authTransactionReducer.prototype.rehydrateOptions = REHYDRATE_OPTIONS;
